import Button from '../actions/Button';
import Box from '../layout/box/Box';
import Modal from './Modal';
import React from 'react';
import {useTranslation} from 'react-i18next';

export interface MessageModalLayoutProps {
  className?: string;
  isOpen: boolean;
  onlyConfirm?: boolean | undefined;
  title: string;
  content: string | React.ReactNode;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  primaryButtonOnClick?: () => void;
  secondaryButtonOnClick?: () => void;
}

export default function MessageModalLayout({
  className,
  isOpen,
  onlyConfirm = false,
  title,
  content,
  // primaryButtonText = '네',
  // secondaryButtonText = '아니요',
  primaryButtonText,
  secondaryButtonText,
  primaryButtonOnClick,
  secondaryButtonOnClick,
}: MessageModalLayoutProps) {
  const {t} = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      position='top'
      className='items-start !rounded-[1.25rem] !shadow-none'
      backgroundColor='rgba(0,0,0,0)'
      closeOnOutsideClick
      onClose={secondaryButtonOnClick}>
      <Box
        className={`top-0 w-[30rem] p-[1.625rem] bg-white rounded-[1.25rem] shadow-[0_2px_10px_0px_rgba(189,189,189,0.5)] ${className}]`}
        width='w[30rem]'
        direction='vertical'>
        <div className='text-lg font-bold leading-[1.625rem]'>{title}</div>

        <div className='pt-[0.625rem] text-base font-normal'>{content}</div>

        <Box className='gap-4 pt-[1.25rem]' align='right'>
          {!onlyConfirm && (
            <Button
              label={secondaryButtonText || t('modal.disapprove')}
              priority='primary'
              className='w-[6.5rem] font-normal !text-base !rounded-[0.625rem]'
              onClick={secondaryButtonOnClick}
            />
          )}
          <Button
            label={primaryButtonText || t('modal.approve')}
            skin='primary'
            priority='primary'
            className='w-[6.5rem] font-normal !text-base !rounded-[0.625rem]'
            onClick={primaryButtonOnClick}
          />
        </Box>
      </Box>
    </Modal>
  );
}
